/**
 * @file ItemCodeDescription.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-21
 * @modified 2026-10-23
 * @description A line's item code as a badge to the LEFT of its words, in one
 *              cell — the expanded line tables of Search Bills, Search POs
 *              (Purchase description), Search Invoices (Sales description) and
 *              Search Customer Orders' PO lines (Purchase description).
 *
 *   Cam, 21 Oct 2026: "remove the item # column and put item number as badge
 *   left of description". The badge is the tables' .account-badge-inline pill;
 *   it opens the item (EntityLink) where the line resolves to one, and is plain
 *   where it does not. No code → the words alone, no empty pill. The words are
 *   the line's own record and are never replaced by the catalogue name.
 *
 *   <ItemCodeDescription code={line.item_code} itemId={line.item_id}
 *                        description={line.description} />
 *
 *   1.1.0 (2026-10-23, Cam): `stacked` puts the code above the words (Search
 *   Customer Orders' expanded lines: "Item (code above name)").
 */

import React from 'react';
import EntityLink from './EntityLink';
import './ItemCodeDescription.css';

function ItemCodeDescription({ code, itemId = null, description, empty = '-', stacked = false, children = null }) {
  const trimmed = String(code ?? '').trim();
  const words = String(description ?? '').trim();
  return (
    <span className={`item-code-description${stacked ? ' stacked' : ''}`}>
      {trimmed && (
        <EntityLink
          type="inventory_item"
          id={itemId}
          variant="badge"
          className="account-badge-inline item-code-badge"
          title={itemId ? `View item ${trimmed}` : undefined}
        >
          {trimmed}
        </EntityLink>
      )}
      <span className="item-code-description-text">
        {words || (trimmed ? '' : empty)}
        {children}
      </span>
    </span>
  );
}

export default ItemCodeDescription;
